import { render } from "./Singlesupport.vue?vue&type=template&id=895830ae"
import script from "./Singlesupport.vue?vue&type=script&lang=js"
export * from "./Singlesupport.vue?vue&type=script&lang=js"

import "./Singlesupport.vue?vue&type=style&index=0&id=895830ae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__